import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthFacade } from '@vasta/client-core-authentication';

export const tenantRedirectGuard = () => {
  const auth = inject(AuthFacade);
  const router = inject(Router);

  return auth.whenUserSettled$.pipe(
    map(() => {
      const tenants = auth.tenants();
      if (tenants.length > 0) {
        return router.createUrlTree([
          tenants[0].externalId,
          'scheduling',
          'schedule',
        ]);
      }
      return router.createUrlTree(['tenants', 'new']);
    }),
  );
};
